<template>
  <div>
    <Form class="i-form" inline>
      <FormItem prop="project" label="项目：" :label-width="84">
        <Select v-model="queryParams.project" placeholder="请选择" clearable style="width: 160px;">
            <Option value="布草洗涤费" label="布草洗涤费">布草洗涤费</Option>
            <Option value="易耗品费" label="易耗品费">易耗品费</Option>
          </Select>
      </FormItem>
      <FormItem prop="content" label="操作内容：" :label-width="95">
        <Input type="text" v-model="queryParams.content" clearable placeholder="关键字"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="searchBtn" :loading="loading">查询</Button>
      </FormItem>
    </Form>
    <Content>
      <Table stripe :loading="loading" :columns="columns" :data="recordList" style="width: 1222px;"></Table>
      <div style="margin: 10px 10px 30px 10px; overflow: hidden">
        <Page show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.page" 
          :page-size="queryParams.size"
          @on-page-size-change="changePageSize" 
          @on-change="changePage">
        </Page>
      </div>
    </Content>
  </div>
</template>

<script>
/* eslint-disable */
import API from '@/api'
import Utils from '@/utils'

export default {
  data () {
    return {
      loading: false, // 查询按钮loading
      queryParams: { // 传给接口的查询字段
        project: '', // 项目
        content: '', // 操作内容
        page: 1, // 当前页数
        size: 10 // 每页显示的条数
      },
      recordList: [], // 表格数据
      listCount: 0, // 分页
      columns: [ // 表头
        {
          title: "操作时间",
          key: "modifyDate",
          align: "center",
          width: 200
        },
        {
          title: "操作人",
          align: "center",
          width: 120,
          render: (h, params) => {
            return h('div', {}, params.row.modifier || '-')
          }
        },
        {
          title: "项目",
          key: "project",
          align: "center",
          width: 120
        },
        {
          title: "操作内容",
          key: "content",
          align: "center",
          width: 180
        },
        {
          title: "原信息",
          align: "center",
          width: 300,
          render:(h, params) => {
            return h('div', {}, (function() {
                if (params.row.originValue.includes('床数')) {
                  let valueList = params.row.originValue.split('床数').splice(1)
                  let domList = []
                  valueList.map(item => {
                    domList.push(h('p', {
                      style: {
                        textAlign: 'left',
                        margin: '5px 0'
                      }
                    }, '床数' + item))
                  })
                  return domList
                } else {
                  return params.row.originValue
                }
              })()
            )
          }
        },
        {
          title: "新信息",
          align: "center",
          width: 300,
          render:(h, params) => {
            return h('div', {}, (function() {
                if (params.row.modifiedValue.includes('床数')) {
                  let valueList = params.row.modifiedValue.split('床数').splice(1)
                  let domList = []
                  valueList.map(item => {
                    domList.push(h('p', {
                      style: {
                        textAlign: 'left',
                        margin: '5px 0'
                      }
                    }, '床数' + item))
                  })
                  return domList
                } else {
                  return params.row.modifiedValue
                }
              })()
            )
          }
        },
      ]
    }
  },

  created () {
		this.token = Utils.findFromLocalStorage('vue-token');
		this.username = Utils.findFromLocalStorage('vue-username');
		this.env = Utils.findFromLocalStorage('env', 'dev');
    this.AuthorToken = Utils.findFromLocalStorage('Author-token');
    this.headerENV = Utils.aliHeaderEnv(this.env)
    this.aliyunTestENV = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
  },

  mounted () {
    this.$Notice.config({
			top: 150
    })
    if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
      this.$Notice.error( {
        title: '无权限操作'
      })
      return
    }
    this.attachedChargingModifyRecord()
  },

  methods: {
    //  查询按钮
    searchBtn () {
      this.queryParams.page = 1
      this.attachedChargingModifyRecord()
    },

    // 清洁单附属费用设置-操作记录
    async attachedChargingModifyRecord () {
      if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
        this.$Notice.error( {
          title: '无权限操作'
        })
        return
      }
      this.loading = true
      let params = this.queryParams
      console.info(params)
      let res = (await API.omsAPI[this.env].clientServer.attachedChargingModifyRecord(params, {
        'x-ca-stage': this.headerENV,
        'Authorization': this.AuthorToken,
        // 'Right': this.token,
        // 'group': this.aliyunTestENV
      })).data
      if (res.retCode) {
        this.loading = false
        this.$Notice.error( {
          title: res.msg,
          desc: "获取操作记录失败"
        })
        return
      }
      this.recordList = res.data.content
      this.listCount = res.data.totalCount
      this.loading = false
    },

    // 分页
    changePageSize (size) {
      this.queryParams.page = 1
      this.queryParams.size = size
      this.attachedChargingModifyRecord()
    },

    changePage (pageIndex) {
      this.queryParams.page = pageIndex
      this.attachedChargingModifyRecord()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/cleaner/additional-fee/operate-record.vue